export const safeSessionStorageGetItem = (key) => {
  try {
    if (typeof window === "undefined" || !window.sessionStorage) return null;
    return window.sessionStorage.getItem(key);
  } catch (error) {
    console.warn("SESSION_STORAGE_GET_FAILED", { key, error });
    return null;
  }
};

export const safeSessionStorageSetItem = (key, value) => {
  try {
    if (typeof window === "undefined" || !window.sessionStorage) return false;
    window.sessionStorage.setItem(key, value);
    return true;
  } catch (error) {
    console.warn("SESSION_STORAGE_SET_FAILED", { key, error });
    return false;
  }
};

export const safeSessionStorageRemoveItem = (key) => {
  try {
    if (typeof window === "undefined" || !window.sessionStorage) return false;
    window.sessionStorage.removeItem(key);
    return true;
  } catch (error) {
    console.warn("SESSION_STORAGE_REMOVE_FAILED", { key, error });
    return false;
  }
};
